import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Userreportyeppy = () => {
  return (
    <div className="userreport_yeppy p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={4} xxl={4} className="my-auto">
            <h2>User Report</h2>
            <div className="report_main">
              <div className="user_report_main">
                <div className="user_report_box">
                  <div className="user_report_img">
                    <StaticImage
                      src="../../../images/case-studies/yeppy/user_report_img.png"
                      alt="TekRevol"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["png"]}
                      width={140}
                    />
                  </div>
                  <div className="user_report_content">
                    <h6>User:</h6>
                    <p>Nabiha</p>
                    <div className="user_report_down">
                      <h6>User Testing Tasks:</h6>
                      <p>
                        During user testing, Nabiha was given specific tasks to
                        evaluate the Super App for Groceries:
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user_report_second">
                <div className="user_report_second_content">
                  <ul>
                    <li>
                      <strong>Task 1:</strong> Shop for a week's worth of
                      groceries, including fresh produce, baby food, and your
                      favorite international snacks.
                    </li>
                    <li>
                      <strong>Task 2:</strong> Apply available discounts and
                      deals to your cart to ensure cost savings.
                    </li>
                    <li>
                      <strong>Task 3:</strong> Schedule a grocery delivery at a
                      time that works best for your daily routine.
                    </li>
                    <li>
                      <strong>Task 4:</strong> Explore the variety of products
                      available, especially in the international and specialty
                      sections.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={7} xl={8} xxl={8}>
            <div className="user_report_mob_img">
              <StaticImage
                src="../../../images/case-studies/yeppy/user_report.png"
                alt="TekRevol"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1000}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Userreportyeppy;
